const state = {
    user: {
        loggedIn: false,
        data: null,
        roles: null,
    },
}
export default state;